export const CATEGORIES = [
  { slug: "shops", name: "Shops, Shopping Centres & Supermarkets", short: "Shops & Supermarkets", icon: "ShoppingBag",
    blurb: "High streets, superstores and shopping centres graded for accessibility." },
  { slug: "facilities", name: "Facilities & Parking", short: "Facilities & Parking", icon: "ParkingCircle",
    blurb: "Public toilets, Blue Badge parking, libraries and community facilities." },
  { slug: "hospitality", name: "Hospitality", short: "Hospitality", icon: "Utensils",
    blurb: "Restaurants, cafés, pubs and hotels welcoming to every guest." },
  { slug: "offices", name: "Offices & Workspaces", short: "Offices & Workspaces", icon: "Briefcase",
    blurb: "Workplaces designed to include everyone, from meeting rooms to reception." },
  { slug: "attractions", name: "Tourist Attractions", short: "Tourist Attractions", icon: "Landmark",
    blurb: "Museums, heritage sites and days out — reviewed for real accessibility." },
  { slug: "care", name: "Care Facilities", short: "Care Facilities", icon: "HeartHandshake",
    blurb: "Care homes, day centres and health services rated by inspectors." },
];

export const AREAS = ["Swindon", "Wiltshire"];

export const ACCESSIBILITY_AREAS = [
  "Wheelchair & Physical Access",
  "Visual Accessibility",
  "Deaf & Hard-of-Hearing Accessibility",
  "Cognitive Accessibility",
  "Neurodivergent Accessibility",
  "Communication Accessibility",
  "Accessible Toilets & Facilities",
  "Accessible Parking",
  "Assistance Dog Friendly",
  "Accessible Customer Service & Staff Support",
  "Accessible Information, Website & Digital Services",
];

export const NOMINATOR_CONNECTIONS = [
  "Customer/Visitor",
  "Employee",
  "Employer/Owner",
  "Accessibility Professional",
  "Family Member/Carer",
  "Organisation Representative",
  "Other",
];

export const DEFAULT_INSPECTION_TEMPLATE = [
  { section: "Approach & Parking", items: [
    { item: "Blue Badge parking available", score: 0, notes: "" },
    { item: "Level or ramped approach", score: 0, notes: "" },
    { item: "Clear signage from car park", score: 0, notes: "" },
  ]},
  { section: "Entrance", items: [
    { item: "Step-free entrance", score: 0, notes: "" },
    { item: "Automatic or easy-open doors", score: 0, notes: "" },
    { item: "Adequate door width (≥ 800mm)", score: 0, notes: "" },
  ]},
  { section: "Inside the Venue", items: [
    { item: "Circulation space & wide aisles", score: 0, notes: "" },
    { item: "Lift or level access to all floors", score: 0, notes: "" },
    { item: "Accessible toilet available", score: 0, notes: "" },
    { item: "Seating & rest areas", score: 0, notes: "" },
  ]},
  { section: "Sensory & Communication", items: [
    { item: "Hearing loop / clear audio", score: 0, notes: "" },
    { item: "Large print or braille materials", score: 0, notes: "" },
    { item: "Calm, low-stimulus areas", score: 0, notes: "" },
  ]},
  { section: "Staff & Service", items: [
    { item: "Trained, welcoming staff", score: 0, notes: "" },
    { item: "Assistance dogs welcomed", score: 0, notes: "" },
  ]},
];
